var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useState } from "react";
import { Box, VStack, HStack, FormControl, FormLabel, Input, Flex, Button, Select, useToast, } from "@reverb-ui/react";
import { RequiredIndicator } from "@/features/first-access/presentation/components/required-indicator";
import { useForm, Controller } from "react-hook-form";
import { UtilContext } from "@/shared/presentation/context-api/providers/util";
import { CompanyWizardContext } from "@/features/first-access/presentation/context-api/company-wizard-provider";
export var CompanyForm = function (_a) {
    var hasNextStep = _a.hasNextStep, hasPreviousStep = _a.hasPreviousStep, goToNextStep = _a.goToNextStep, goToPrevStep = _a.goToPrevStep, setLocationId = _a.setLocationId;
    var _b = useForm(), handleSubmit = _b.handleSubmit, register = _b.register, control = _b.control;
    var _c = useContext(UtilContext), companySizes = _c.companySizes, countries = _c.countries, documentTypes = _c.documentTypes, industries = _c.industries;
    var createCompanyAndOwner = useContext(CompanyWizardContext).createCompanyAndOwner;
    var _d = useState(false), creatingCompanyAndOwner = _d[0], setCreatingCompanyAndOwner = _d[1];
    var toast = useToast();
    var submit = function (values) {
        setCreatingCompanyAndOwner(true);
        createCompanyAndOwner({
            employeeRangeId: values.companySize.value,
            industryTypeId: values.industry.value,
            locationId: values.country.value,
            documentTypeId: values.documentType.value,
            documentNumber: values.documentNumber,
            name: values.name,
            tradeName: values.tradeName,
            website: values.website,
        })
            .then(function () {
            setLocationId(values.country.value);
            goToNextStep();
        })
            .catch(function (e) {
            return toast({
                status: "error",
                title: e.message,
                duration: 3000,
                isClosable: true,
            });
        })
            .finally(function () { return setCreatingCompanyAndOwner(false); });
    };
    var nameValidator = {
        required: true,
    };
    var documentValidator = {
        required: true,
    };
    var requiredValidator = {
        required: true,
    };
    return (React.createElement(Box, { w: "full" },
        React.createElement("form", null,
            React.createElement(VStack, { spacing: 8 },
                React.createElement(HStack, { w: "full", spacing: 5 },
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Company name"),
                        React.createElement(Input, __assign({}, register("name", nameValidator)))),
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Trade name"),
                        React.createElement(Input, __assign({}, register("tradeName", nameValidator))))),
                React.createElement(HStack, { w: "full", spacing: 5 },
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Company size"),
                        React.createElement(Controller, { control: control, name: "companySize", rules: requiredValidator, render: function (_a) {
                                var field = _a.field;
                                return (React.createElement(Select, __assign({}, field, { options: companySizes.map(function (_a) {
                                        var description = _a.description, id = _a.id;
                                        return ({
                                            label: description,
                                            value: id,
                                        });
                                    }) })));
                            } })),
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Industry"),
                        React.createElement(Controller, { control: control, name: "industry", rules: requiredValidator, render: function (_a) {
                                var field = _a.field;
                                return (React.createElement(Select, __assign({}, field, { options: industries.map(function (_a) {
                                        var description = _a.description, id = _a.id;
                                        return ({
                                            label: description,
                                            value: id,
                                        });
                                    }) })));
                            } }))),
                React.createElement(HStack, { w: "full", spacing: 5 },
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Document type"),
                        React.createElement(Controller, { control: control, name: "documentType", rules: requiredValidator, render: function (_a) {
                                var field = _a.field;
                                return (React.createElement(Select, __assign({}, field, { options: documentTypes.map(function (_a) {
                                        var description = _a.description, id = _a.id;
                                        return ({
                                            label: description,
                                            value: id,
                                        });
                                    }) })));
                            } })),
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Document number"),
                        React.createElement(Input, __assign({}, register("documentNumber", documentValidator))))),
                React.createElement(HStack, { w: "full", spacing: 5 },
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Location"),
                        React.createElement(Controller, { control: control, name: "country", rules: requiredValidator, render: function (_a) {
                                var field = _a.field;
                                return (React.createElement(Select, __assign({}, field, { options: countries.map(function (_a) {
                                        var description = _a.description, id = _a.id;
                                        return ({
                                            label: description,
                                            value: id,
                                        });
                                    }) })));
                            } })),
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Website"),
                        React.createElement(Input, __assign({}, register("website", requiredValidator))))))),
        React.createElement(Flex, { justifyContent: "space-between", pt: 8, pb: 3 },
            React.createElement(Box, null, hasPreviousStep && (React.createElement(Button, { isDisabled: creatingCompanyAndOwner, colorScheme: "blue", onClick: goToPrevStep }, "Previous"))),
            React.createElement(Flex, null, hasNextStep && (React.createElement(Button, { isDisabled: creatingCompanyAndOwner, colorScheme: "blue", onClick: handleSubmit(submit) }, "Next"))))));
};
